import { Platform, TouchableOpacity, View } from 'react-native';
import React from 'react';
import { Text } from '~/components';
import type { SvgProps } from 'react-native-svg';
import { twMerge } from 'tailwind-merge';

interface Props {
  icon: React.FC<SvgProps>;
  onPress?: () => void;
  children: React.ReactNode;
}

const ActionButton = ({ icon: Icon, onPress, children }: Props) => {
  return (
    <TouchableOpacity
      className="flex-column mx-3"
      onPress={onPress}
      activeOpacity={0.9}
    >
      <View
        className={twMerge(
          'h-[60px] w-[60px] rounded-2xl items-center justify-center bg-light-100',
          Platform.OS !== 'android' ? 'shadow-md' : ''
        )}
        style={{ elevation: 2 }}
      >
        <Icon />
      </View>
      <Text className="max-w-[60px] text-center mt-[10px]">{children}</Text>
    </TouchableOpacity>
  );
};

export default ActionButton;
